import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../Interface';

const ConfigFields = ({ viewField, autoCompleteOptions, formData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-3 xl:col-span-2 col-span-6">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Cég neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="shortName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Cég rövid neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.shortName} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.shortName && values.shortName !== '' }}
        />
      </div>
      <div className=" md:col-span-3 xl:col-span-2 col-span-6">
        <Field
          type="text"
          name="nameInPrint"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Nyomtatásban megjelenő név" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.nameInPrint} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.nameInPrint && values.nameInPrint !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="autocomplete"
          name="countryCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Ország" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.countryCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('countryCode', newVal?.value ?? null).then(() => {
              validateField('countryCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.countryCode !== '' }}
          selectedValue={values.countryCode}
          selectedLabelValue={formData?.country?.name}
          dataset={autoCompleteOptions.country}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="province"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megye" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.province} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.province && values.province !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="postCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Irányítószám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.postCode} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.postCode && values.postCode !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="city"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Város" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.city} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.city && values.city !== '' }}
        />
      </div>

      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="streetAddress"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Utca, házszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.streetAddress} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.streetAddress && values.streetAddress !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="website"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Weboldal" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.website} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.website && values.website !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="email"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Email cím" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.email} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.email && values.email !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="phoneNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Telefonszám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.phoneNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.phoneNumber && values.phoneNumber !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="GLN"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="GLN" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.GLN} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.GLN && values.GLN !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="hunTaxNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Magyar adószám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.hunTaxNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.hunTaxNumber && values.hunTaxNumber !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="text"
          name="euTaxNumber"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="EU adószám" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.euTaxNumber} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.euTaxNumber && values.euTaxNumber !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-2 col-span-6">
        <Field
          type="text"
          name="other"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Egyéb" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.other} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.other && values.other !== '' }}
        />
      </div>
    </div>
  );
};

export default ConfigFields;
